import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox} from 'semantic-ui-react';
import {injectIntl, intlShape} from 'react-intl';

import AutoSaveField from './abstract/AutoSaveField.jsx';

class AutoSaveCheckboxOptions extends React.Component {
    getValue(event, data, option) {
        let values = (this.props.defaultValue || []).slice();
        if (data.checked) {
            values.push(option.value);
        } else {
            let index = values.indexOf(option.value);
            values.splice(index, 1);
        }
        return values;
    }

    get options() {
        return (this.props.field && this.props.field.options ? this.props.field.options : this.props.options) || [];
    }

    get multiOptions() {
        let options = this.options.map((item) => ({
            text: item.text || (item.textKey ? this.props.intl.formatMessage({id: item.textKey}) : ""),
            value: item.value,
            key: item.key
        }));

        let multiOptionsObj = {
            options: options,
            currentValue: this.props.defaultValue,
            colCount: options.length > 1 ? 2 : options.length
        };

        if ( this.props.colCount ) { multiOptionsObj.colCount = this.props.colCount; }

        return multiOptionsObj;
    }

    render() {
        return (
            <AutoSaveField control={Checkbox}
                           fieldLabel={this.props.fieldLabel}
                           getValueFromOnChange={(event, data, options) => this.getValue(event, data, options)}
                           multiOptions={this.multiOptions}
                           name={this.props.name}
                           {...this.props} />
        );
    }
}

AutoSaveCheckboxOptions.propTypes = {
    intl: intlShape,
    options: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        key: PropTypes.string
    }))
};

export default injectIntl(AutoSaveCheckboxOptions);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveCheckboxOptions.jsx